import type { BorderCondition } from 'dorian-shared/types/branch/HubOption';

const HEX_RE = /^#[0-9a-fA-F]{6}([0-9a-fA-F]{2})?$/;

export function isValidBorderHex(color: string | null | undefined): boolean {
  if (color == null || color === '') return false;
  return HEX_RE.test(color);
}

export function isBorderConditionValid(c: BorderCondition): boolean {
  if (!isValidBorderHex(c.color)) return false;
  const subsValid = c.subConditions.length > 0 && c.subConditions.every((sub) => {
    if (sub.variableId == null) return false;
    const hasInt = sub.intValue !== undefined && sub.intValue !== '';
    const hasVar = sub.varValue !== undefined && sub.varValue !== null && sub.varValue !== 0;
    return hasInt || hasVar;
  });
  return subsValid;
}
